/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Tier2ServiceDeclineResponse
 */
export interface Tier2ServiceDeclineResponse {
    /**
     * 
     * @type {string}
     * @memberof Tier2ServiceDeclineResponse
     */
    tier2Id?: string | null;
}

/**
 * Check if a given object implements the Tier2ServiceDeclineResponse interface.
 */
export function instanceOfTier2ServiceDeclineResponse(value: object): value is Tier2ServiceDeclineResponse {
    return true;
}

export function Tier2ServiceDeclineResponseFromJSON(json: any): Tier2ServiceDeclineResponse {
    return Tier2ServiceDeclineResponseFromJSONTyped(json, false);
}

export function Tier2ServiceDeclineResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tier2ServiceDeclineResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tier2Id': json['tier2Id'] == null ? undefined : json['tier2Id'],
    };
}

export function Tier2ServiceDeclineResponseToJSON(json: any): Tier2ServiceDeclineResponse {
    return Tier2ServiceDeclineResponseToJSONTyped(json, false);
}

export function Tier2ServiceDeclineResponseToJSONTyped(value?: Tier2ServiceDeclineResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tier2Id': value['tier2Id'],
    };
}

